'use client'

import {IProductVideo} from "@/entities";
import Image from "next/image";
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/pagination';
import { useRef } from 'react'

type TProps = {
	videos: IProductVideo[],
	openVideoPlayer: (location: string) => void
}

const VideosSlider = ({videos, openVideoPlayer}: TProps) => {

	const swiperRef = useRef<SwiperRef>(null);

	return (
		<div className="right-side">
			<Swiper
				ref={swiperRef}
				className="product-carousel"
				slidesPerView={1}
				loop={true}
				spaceBetween={15}
				pagination={{
					clickable: true,
					el: '.swiper-pagination'
				}}
				modules={[Pagination]}
			>
				{videos.map((x, index) => {
					return (
						<SwiperSlide key={index} className="item">
							<div
								className="img-box cursor-pointer"
								onClick={() => openVideoPlayer(x.location)}
							>
								<Image
									src={x.cover}
									alt={x.alt}
									width={800}
									height={500}
									className="object-fit-cover w-100"
								/>
								<button
									type="button"
									className="play-btn btn btn-primary video-btn"
									aria-label="Play"
									onClick={() => openVideoPlayer(x.location)}
								></button>
							</div>
						</SwiperSlide>
					)
				})}

				<div className="swiper-pagination"></div>
				{videos.length > 1 && <div className="swiper-button-prev cursor-pointer" onClick={() => swiperRef.current?.swiper.slidePrev()}></div>}
				{videos.length > 1 && <div className="swiper-button-next cursor-pointer" onClick={() => swiperRef.current?.swiper.slideNext()}></div>}
			</Swiper>
		</div>
	)
}

export default VideosSlider